import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.29 18.71c.2.2.45.29.71.29s.51-.1.71-.29l6-6a1 1 0 0 0 0-1.42l-6-6A.996.996 0 1 0 21.3 6.7l4.29 4.29H11c-2.14 0-4.15.83-5.66 2.34A7.95 7.95 0 0 0 3 18.99c0 2.14.83 4.15 2.34 5.66A7.95 7.95 0 0 0 11 26.99h11c.55 0 1-.45 1-1s-.45-1-1-1H11c-1.6 0-3.11-.62-4.24-1.76A5.97 5.97 0 0 1 5 18.99c0-1.6.62-3.11 1.76-4.24A5.97 5.97 0 0 1 11 12.99h14.59l-4.29 4.29a.996.996 0 0 0 0 1.41z"
    />
  </svg>
);
const SvgIconArrowUUpRight = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowUUpRight);
export default Memo;
